import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polygon
    {...props}
    points="47.92 25.07 47.92 47.83 29.37 47.9 13.64 38.16 29.67 10.59 47.92 25.07"
  />
);

export let ArtworkJackieBrown = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.jackieBrown}
    renderShadow={renderShadow}
  >
    <g
      style={{
        transform: 'scale(1.1) translate(-2px,-2px)',
      }}
    >
      <path
        style={{
          fill: '#52391b',
          stroke: '#453622',
          strokeWidth: 0.5,
          strokeMiterlimit: 10,
        }}
        d="M15.62,18.97c-3.75,1.9-4.69,7.31-4.98,8.81-.27,1.38.33,3.17,2.37,3.56-.33-.25-.88-.55-1.15-.97s-.5-1.2.04-1.52c1.03.94-.51,3.59-.5,4.35,0,2.02,1.03,4.81,2.85,5.2.28-3.06,1.29-1.14,2.01-2.28,1.2,1.53-.4,1.78,2.35,2.16-.84-1.44,2.02-.91,1.25-2.36s2.85-1.73,3.47-3.21"
      />
      <path
        style={{
          fill: '#52391b',
          stroke: '#453622',
          strokeWidth: 0.5,
          strokeMiterlimit: 10,
        }}
        d="M16.76,12.64c-.34-.81,1.77-2.5,2.7-2.87,2.73-1.09,8.21-.92,10.21.82.85.74,2.09,3.52,2.31,4.3.29,1.06.53,2.16.34,3.23s-.91,2.14-2.05,2.55c-.86.32-1.84.24-2.75.09-2.54-.39-5-1.21-7.19-2.41-1.09-.59-2.19-1.39-2.4-2.5"
      />
      <path
        style={{
          fill: '#52391b',
          stroke: '#453622',
          strokeWidth: 0.5,
          strokeMiterlimit: 10,
        }}
        d="M30.13,18.12c3.56.85,5.47,9.09,6.01,12.51.12.74.09,2.68-.82,2.88.32.72,1.7.56,1.82-.21.17.66-.39,1.32-1.06,1.56s-1.41.16-2.12.08c.33.81,1.58,1.11,2.28.55.13.58-.21,1.19-.71,1.56s-1.1.58-1.71.74c-1.98.52-3.66-.54-4.93-1.51-1.19-.91-2.06-1.51-3.01-3.12s-4.84-2.16-5.08-3.98c-.31-2.34-.25-4.75.52-6.99s2.29-4.29,4.44-5.47"
      />
      <path
        style={{ strokeWidth: 0, fill: '#d4501f' }}
        d="M26.61,31.1c.09-.04.18-.08.27-.05.08.03.13.1.17.17.4.73.78,1.61.49,2.05-.88,1.32-4.2,1.45-6.22,1.31-1.02-.07-2.34-.22-2.9-1.08-.51-.79-.17-1.65.77-1.97,1.05-.36,2.2.02,3.25.14,1.41.17,2.88-.01,4.16-.57Z"
      />
      <path
        style={{ strokeWidth: 0, fill: '#b8451b' }}
        d="M22.14,34.58c-1.18.39-.34,2.23-.32,3.12.06,2.45.02,3.73-1.46,6.32.34.05,4.6-2.69,4.59-6.08,0-.88-1.44-3.81-2.27-4.12l-.54.76Z"
      />
      <path
        style={{ strokeWidth: 0, fill: '#d4501f' }}
        d="M20.96,33.38c-.71.44-1.34,1.02-1.71,1.76-.35.7-.44,1.5-.49,2.28s-.08,1.57-.33,2.32-.74,1.45-1.48,1.74c.79.06,1.55-.31,2.26-.66.35-.17.7-.35.97-.62.29-.29.48-.66.66-1.03.71-1.49.73-2.6,1.28-4.15.17-.49.67-1.39.06-1.79-.5-.33-.8-.09-1.23.17Z"
      />
      <path
        style={{ strokeWidth: 0, fill: '#b8451b' }}
        d="M22.32,32.65c.36.23.67.74.65,1.25-.01.33-.17.59-.35.78-.34.35-.8.5-1.26.39s-.91-.46-1.22-.96c-.14-.23-.27-.53-.22-.79.04-.21.18-.34.31-.44.63-.49,1.29-.74,2.07-.23Z"
      />
      <path
        style={{ strokeWidth: 0, fill: '#c2761f' }}
        d="M30.71,19.87c0,1.95-.4,6.49-.92,8.16-.56,1.82-4.39,5.71-6.63,5.71-2.08,0-6.46-4.14-6.79-5.8-.26-1.28-.93-5.34-.93-7.06,0-5.38,3.37-7.59,7.72-7.59s7.55,1.2,7.55,6.58Z"
      />
      <path
        style={{ strokeWidth: 0, fill: '#c2761f' }}
        d="M30.15,22.56c-.09,1.74.18,2.77.67,2.77s1.39-1.77,1.39-3.17-.52-2.03-1-1.9c-.92.25-.99.92-1.06,2.31Z"
      />
      <path
        style={{ strokeWidth: 0, fill: '#ad3c24' }}
        d="M20.8,29.98c.12.32.54.4,1.05.56.62.2,2.38.17,3-.01.49-.14,1.05-.55,1.01-.57-.03-.01-1.28-.22-2.53-.21s-2.53.23-2.53.23Z"
      />
      <path
        style={{ fill: '#9c1f1a', strokeWidth: 0 }}
        d="M20.8,29.98c.42-.48,1.34-1.24,2.53-1.01,1.19-.1,2.1.52,2.53,1,.02.02-1.61-.13-2.53-.13s-2.53.15-2.53.15Z"
      />
      <path
        style={{
          fill: '#52391b',
          stroke: '#453622',
          strokeWidth: 0.5,
          strokeMiterlimit: 10,
        }}
        d="M16.94,17.92c.39-2.08,2.29-3.34,4.73-4.25-.93-.66-3.7-2.32-5.19-1.78-1.02.37-2.77,2.39-2.93,4.54s1.44,3.89,2.08,5.05c.69,1.24,1.24-3.18,1.31-3.56Z"
      />
      <path
        style={{ strokeWidth: 0, fill: '#c2761f' }}
        d="M16.06,22.64c.09,1.74-.18,2.77-.67,2.77s-1.39-1.77-1.39-3.17.52-2.03,1-1.9c.92.25.99.92,1.06,2.31Z"
      />
      <circle
        style={{
          fill: 'none',
          stroke: '#ffb200',
          strokeMiterlimit: 10,
          strokeWidth: 0.25,
        }}
        cx="15.35"
        cy="25.11"
        r=".31"
      />
      <circle
        style={{ strokeWidth: 0, fill: '#ffb200' }}
        cx="15.35"
        cy="26.46"
        r=".46"
      />
      <line
        style={{
          strokeWidth: 0.35,
          fill: 'none',
          stroke: '#ffb200',
          strokeMiterlimit: 10,
        }}
        x1="15.35"
        y1="26.21"
        x2="15.35"
        y2="25.43"
      />
      <circle
        style={{
          fill: 'none',
          stroke: '#ffb200',
          strokeMiterlimit: 10,
          strokeWidth: 0.25,
        }}
        cx="30.79"
        cy="25.11"
        r=".31"
      />
      <circle style={{ strokeWidth: 0 }} cx="30.79" cy="26.46" r=".46" />
      <line
        style={{
          strokeWidth: 0.35,
          fill: 'none',
          stroke: '#ffb200',
          strokeMiterlimit: 10,
        }}
        x1="30.79"
        y1="26.21"
        x2="30.79"
        y2="25.43"
      />
      <path
        style={{
          fill: '#52391b',
          stroke: '#453622',
          strokeWidth: 0.5,
          strokeMiterlimit: 10,
        }}
        d="M26.34,10.19c2.49-.11,5.14,1.24,5.86,3.31.4,1.15.2,2.38.12,3.57s-.01,2.48.81,3.46c-2-.28-3.05-2.27-3.54-3.72.17,1.62.04,2.4,1.17,3.57-.98.12-3.11-2.25-3.76-3.25-.43-.67-.92-1.98-1.89-2.59-1.75-1.09-3.84.18-4.05-1.51-.2-1.6,3.56-2.78,5.28-2.85Z"
      />
      <path
        style={{ strokeWidth: 0, fill: '#b87e39' }}
        d="M21.99,22.06c0,.1-.04.15-.06.18-.02.02-.06.04-.09.04-.11,0-.27-.07-.47-.17l-.06-.03c-1.17-.58-2.19-.62-3.09-.13-.04.02-.1,0-.13-.04-.04-.05-.04-.11-.01-.15.52-.82,1.39-1.29,2.21-1.21.52.05,1.03.33,1.38.76.12.15.33.49.34.75Z"
      />
      <path
        style={{ strokeWidth: 0, fill: '#b87e39' }}
        d="M28.57,21.82s-.08.07-.13.04c-.92-.46-1.92-.39-3.08.22l-.06.04c-.2.11-.36.19-.47.18-.04,0-.07-.01-.1-.04-.03-.02-.08-.07-.08-.17.01-.26.2-.61.33-.76.33-.44.84-.74,1.34-.8.83-.1,1.71.34,2.25,1.14.03.04.03.1,0,.15Z"
      />
    </g>
  </AvatarArtwork>
);
